import React, { FC } from 'react';
import { IconButton } from '@mui/material';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import { IWiseTableAction } from 'components/wise/types';
import { useAppNavigate } from 'hooks';
import { paramsListToPageUrlParser } from 'plugins/util/parser';
import { OpenIcon } from 'assets/icons';

interface IWiseTableOpenActionProps {
  action: IWiseTableAction;
  requestParams?: object;
}

const WiseTableOpenAction: FC<IWiseTableOpenActionProps> = ({ action, requestParams }) => {
  const { search } = useLocation();
  const navigate = useAppNavigate();

  const handleButtonClick = () => {
    if (action.method === 'Redirect' && action.method_params?.page_url) {
      const data = { ...(requestParams ?? {}), ...qs.parse(search) };
      const redirectUrl = paramsListToPageUrlParser(
        action.method_params.page_url,
        action.method_params.params_list || '',
        data
      );
      navigate(redirectUrl);
    }
  };

  return (
    <IconButton
      onClick={handleButtonClick}
      aria-label={action.label}
      size="small"
      sx={{
        padding: '4px'
      }}>
      <OpenIcon />
    </IconButton>
  );
};

export default WiseTableOpenAction;
